tasks-schedules-cell
  .memos
    orders-planner-schedules-memo(each="{empty, index in this.number}" tag-scope="{this.genTagScopeForMemo(index)}" data-index="{index}")
  script(type="typescript").
    this.mixin('tasks.schedules-cell');
